import type { TrackerEntryDto, TrackerEntryUpsertBody } from './patientTrackingTypes';

export const INLINE_NEW_PATIENT_ID = '__inline_new__';

export const emptyTrackerEntryForm = (): TrackerEntryUpsertBody => ({
  pharmacyId: '',
  status: 'Pending',
  patientId: '',
  coveredEntityId: null,
  currentIssue: '',
  enrollmentForm: null,
  changeLog: null,
  internalNote: null
});

export function trackerEntryToBody(t: TrackerEntryDto): TrackerEntryUpsertBody {
  return {
    pharmacyId: t.pharmacyId,
    status: t.status,
    patientId: t.patientId,
    coveredEntityId: t.coveredEntityId,
    currentIssue: t.currentIssue,
    enrollmentForm: null,
    changeLog: t.changeLog,
    internalNote: t.internalNote
  };
}
